/**
 * Format leave day amounts for display (supports negative balances / overdrawn pools).
 */
export function formatSignedLeaveDays(n) {
  if (n == null || n === '') return '0';
  const v = Number(n);
  if (Number.isNaN(v)) return '0';
  return v % 1 === 0 ? String(v) : v.toFixed(1);
}

/**
 * Active-pool allocation vs used (may include expired pools’ used from API).
 * If active allocation is ~0 but used &gt; 0, returns 100 (e.g. all pools expired).
 */
export function leaveUsageRatePercent(usedDays, allocatedActiveDays) {
  const u = Number(usedDays) || 0;
  const a = Number(allocatedActiveDays) || 0;
  if (Math.abs(a) < 1e-9) return u !== 0 ? 100 : 0;
  return (u / a) * 100;
}
